import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import Task from '../list/task/index';

const API_PATH = 'event-polls';

export const TaskManager = {
  objects: {
    ...objectsRHandler(API_PATH, Task),
    copy({ data } = DEFAULT_PARAMS) { // { poll_id: 13907 }
      return rHandler(
        apiService.post(`/${API_PATH}/copy`, data),
        (response) => ({ response, item: new Task(response.data.data, API_PATH) }),
        (error) => ({ error }),
      );
    },
  },
};
